import React from 'react';
import FAIcon from '@fortawesome/react-fontawesome';

import { faTrophyAlt } from 'src/components/icons';
import './testimonials.css';

export default class Testimonials extends React.Component {
  render() {
    return (
      <section className="testimonials">
        <h2 className="testimonials-title">
          Since launch, we've helped teams win over $1M in prize money.
        </h2>
        <div className="testimonials-row">
          <div className="testimonials-col">
            <div className="testimonials-col-row">
              <div className="testimonials-col-image">
                <FAIcon icon={faTrophyAlt} className="testimonials-icon" />
              </div>
              <div className="testimonials-col-quote">
                Playerbase lets me easily review hundreds of hours of game footage and gave me a
                significant advantage at the Major. It made me a better coach and analyst, and I
                believe there’s no better service on the market.
              </div>
            </div>
            <div className="testimonials-col-author">James O’Connor</div>
            <div className="testimonials-col-title">Former coach, Team Liquid</div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/testimonials.js